module.exports = __webpack_public_path__ + "static/media/maf-10.da788e94.png";